// Google Ads コンバージョントラッキング

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

// Google Ads設定
const GOOGLE_ADS_ID = 'AW-17259853244';

// コンバージョンイベントを送信
export const sendConversionEvent = (conversionLabel: string, value?: number) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': `${GOOGLE_ADS_ID}/${conversionLabel}`,
      'value': value,
      'currency': 'JPY'
    });
    console.log('Conversion event sent:', conversionLabel);
  } else {
    console.warn('Google gtag not available');
  }
};

// 画像生成完了時のコンバージョン
export const trackImageGeneration = () => {
  // TODO: Google Ads管理画面でコンバージョンラベルを取得後、ここに設定
  // sendConversionEvent('YOUR_CONVERSION_LABEL');
  
  // 一般的なイベントトラッキング（リマーケティング用）
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'image_generated', {
      'send_to': GOOGLE_ADS_ID,
      'event_category': 'engagement',
      'event_label': 'AI Image Generation'
    });
  }
};

// グッズ作成時のコンバージョン
export const trackMerchandiseCreation = () => {
  // TODO: Google Ads管理画面でコンバージョンラベルを取得後、ここに設定
  // sendConversionEvent('YOUR_CONVERSION_LABEL');
  
  // 一般的なイベントトラッキング（リマーケティング用）
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'merchandise_created', {
      'send_to': GOOGLE_ADS_ID,
      'event_category': 'engagement',
      'event_label': 'Merchandise Creation'
    });
  }
};

// ページビューのトラッキング（リマーケティング用）
export const trackPageView = (pagePath: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      'send_to': GOOGLE_ADS_ID,
      'page_path': pagePath
    });
  }
};

// ユーザーエンゲージメントのトラッキング
export const trackUserEngagement = (action: string, label?: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'user_engagement', {
      'send_to': GOOGLE_ADS_ID,
      'event_category': 'engagement',
      'event_action': action,
      'event_label': label
    });
  }
};